import { Component, Input, OnInit } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FeatureService } from 'src/app/feature/shared/feature.service';
import { Semaine } from 'src/app/feature/shared/models';
import { BreadcrumbItem } from './page-title.model';



@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {


  @Input() breadcrumbItems: BreadcrumbItem[] = [];
  @Input() title: string = '';

  menuSemaineAlert!: string;
  constructor(
    private featureService: FeatureService) { }

  ngOnInit(): void {
    //this._checkIfMenuSemaineCompleted();
  }

  _checkIfMenuSemaineCompleted(){
    this.featureService.getAllSemaines$().subscribe(
      allSemaine => {
        let lastSemaine;
        let newDate = new Date();
        let dateDuJour = new NgbDate(newDate.getUTCFullYear(), newDate.getUTCMonth()+1, newDate.getUTCDate());
        
        let newArray = allSemaine.filter((value : Semaine)  => {
          let dateDeb = this.dateToNgb(new Date(value.dateDebut));
          let dateF = this.dateToNgb(new Date(value.dateFin));

          return  (dateDuJour.after(dateDeb) && dateDuJour.before(dateF)) ||
            (dateDuJour.equals(dateDeb) || dateDuJour.equals(dateF)) 
        });

        if(newArray.length != 0){
          lastSemaine = newArray[0];
          this.featureService.getAllJSTMBySemaineId$(lastSemaine.id).subscribe(
            jstm => {
              let length = jstm.length;
              if(length != 21){
                this.menuSemaineAlert = "notCompleted";
              }
            },
          );
        }else{
          this.menuSemaineAlert = "notFound";
        }
      },
    );

        
  }

  dateToNgb(date: Date): NgbDateStruct{
    //console.log("date debut : ", { day: date.getUTCDate(), month: date.getUTCMonth()+1, year: date.getUTCFullYear()});
    return { year: date.getUTCFullYear(), month: date.getUTCMonth()+1, day: date.getUTCDate()};
  }

}
